"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.travel = travel;

var _calc = require("./calc");

/** 遍历所有路径集合进行计算 */
function travel(data, paths, calculate) {
  paths.forEach(function (path) {
    return (0, _calc.calc)(data, path, function (value) {
      return calculate(value);
    });
  });
}